<template>
    <BaseCardGrid data-spec-class="card-grid-skeleton">
        <BaseCardSkeleton
            v-for="index in size"
            :key="index"
            data-spec-class="card-grid-skeleton__card"
        />
    </BaseCardGrid>
</template>

<script lang="ts" setup>
import { defineProps, withDefaults } from 'vue';

interface Props {
    size?: number;
}

withDefaults(defineProps<Props>(), {
    size: 2,
});
</script>
